// THIS FILE IS ADDED BY @STACKWISEDEV
// FOR VARIANT BUBBLES ON THE PRODUCT GRID CARD
// IF DON'T NEED JUST REMOVE IT

window.addEventListener("load", function() {
    let gridProduct = document.querySelectorAll(".bubble_vriant_fieldset");
    if(gridProduct) {
        gridProduct.forEach((product, index) => {
            let variantBubbles = product.querySelectorAll(".variant_bubble_image");
            variantBubbles.forEach((item, innerIdx) => {
                item.addEventListener("click", function() {
                    let mediaImages = document.querySelectorAll(".product_media_images")[index];
                    let variantImages = mediaImages.querySelectorAll("img");
                    let variantTitle = document.querySelectorAll(".variant_title")[index];
                    if(variantTitle) {
                        variantTitle.innerHTML = item.dataset.optionValue;
                    }
                    Array.from(variantImages).forEach(img => {
                        img.dataset.imageUrl === item.dataset.bubbleImage ? img.style.opacity = '1' : img.style.opacity = '0';
                    });
                });
            });
        });
    }

    let allGridItems = document.querySelectorAll("li.grid__item");
    allGridItems.forEach(gridItem => {
        let mediaActive = gridItem.querySelector("img.media_hover_activated");
        gridItem.addEventListener("mouseenter", () => {
            mediaActive ? mediaActive.style.opacity = "1": "";
        });
        gridItem.addEventListener("mouseleave", () => {
            mediaActive ? mediaActive.removeAttribute("style"): '';
        });
    })
});

